import type { DeliverySlot as DeliverySlotType } from '@@partner:types:app'

import React from 'react'
import classNames from 'classnames'
import { makeSlotLabel } from '@@partner:helpers/slot'

export interface DeliverySlotProps {
  slot: DeliverySlotType
  onSlotSelect?: (slot: DeliverySlotType) => void
  selected: boolean
}

export default function DeliverySlot ({
  slot,
  onSlotSelect,
  selected = false
}: DeliverySlotProps) {
  const handleClick = () => {
    onSlotSelect?.(slot)
  }

  const className = classNames('SlotsTable__Slot__Link', { selected })

  return (
    <div className="SlotsTable__Slot__Body">
      <button type="button" className={className} onClick={handleClick}>
        {makeSlotLabel(slot)}
      </button>
    </div>
  )
}
